module.exports = __webpack_public_path__ + "img/insufficient.ef605c20.png";